//REACT AND REACT BASED LIBRARIES
import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useSWRMutation from "swr/mutation";
//COMPONENTS
import { Box, Container } from "@mui/material";
import AddEditFormCst from "@components/AddEditFormCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import { ColumnInterface } from "@components/Table/types";
//CUSTOM HOOKS AND UTILS
import { useFetchDetail } from "@hooks/useFetchDetail";
import { ServicesURL, uploadFile } from "@utils/utilsApi";
import { useFetchMock } from "src/mock_data/useMockData";
import { MethodType } from "src/services/type";
import { PagesID } from "@utils/utilsConfigurations";
import { fetcher } from "src/services/config";
import { Association } from "src/interfaces/Common";
import { isTrueValue } from "@utils/utilsValidators";
import { useFetchTable } from "@hooks/useFetchDataTable";

const EditLTIAccount: React.FC = () => {
  const { t } = useTranslation(["lti-accounts-page"]);

  const { idLTIAccount } = useParams();

  const navigate = useNavigate();

  const [openAssociations, setOpenAssociations] = useState<
    boolean | Association
  >(false);
  const [corporateAssociation, setCorporateAssociation] = useState<any>([]);

  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();

  //!! CHIAMATA GET
  const { columns, dataTable } = useFetchTable(
    `${ServicesURL.getLTIAccounts}?requestMethod=GET&idCorporateAccount=${idLTIAccount}`, //!! (SOLO DI ESEMPIO) MODIFICARE SERVICE URL CON QUELLO INSERITO NEL FILE DI CONFIG
    PagesID["lti_accounts"], //!! (SOLO DI ESEMPIO) MODIFICARE PAGE ID CON QUELLO INSERITO NEL FILE DI CONFIG
  );

  // const { columns, dataDetail } = useFetchMock(PagesID["lti_accounts"]);

  const { trigger } = useSWRMutation(
    `${ServicesURL.getLTIAccounts}`,
    (url: string, arg: { arg: any }) => {
      return fetcher<any>(`${url}?requestMethod=PUT`, MethodType.POST, {
        ...arg.arg,
      });
    },
  );

  //!! FUNZIONE PER GESTIRE ONSUBMIT DELLA FORM
  const onSubmit = async (inputForm: any) => {
    setOpenToast({ s: StatusEnum.LOADING, message: "loading" }); //!!

    let objToSend = {
      account_name: inputForm.accountName,
      all_corporate_association: inputForm.allCorporateAssociation,
      deployment_id: inputForm.deploymentId,
      launch_request_url: inputForm.launchRequestUrl,
      corporate_id: corporateAssociation?.map((el: any) => +el.id),
      client_id: inputForm.clientId,
      authorization_server_identifier: inputForm.authorizationServerIdentifier,
      id_corporate_account: inputForm.idCorporateAccount,
    };

    try {
      //!!CHIAMATA ON SUBMIT AWAIT
      await trigger(objToSend);
      ////////
      setOpenToast({ s: StatusEnum.OK, message: "" }); //!!
    } catch (error) {
      setOpenToast(undefined); //!!
      console.error(error); //!!
    }
    // mutate && mutate(inputForm)
  };

  const setOpenAssociation = (accessorKey: string, value: boolean) => {
    switch (accessorKey) {
      case "corporates":
        setOpenAssociations(
          value
            ? {
                accessorKey: "corporates",
                mediaType: "corporates",
                type: "table",
                titleKey: "corporate-association",
                pageId: PagesID.corporate,
                service: `${ServicesURL.corporate}?status=ACTIVE`,
              }
            : value,
        );
        break;
    }
  };

  const getValues = (accessorKey: string) => {
    switch (accessorKey) {
      case "corporates":
        return corporateAssociation;
    }
  };

  const handleDelete = (accessorKey: string, e: any) => {
    switch (accessorKey) {
      case "corporates":
        setCorporateAssociation(
          corporateAssociation.filter((element: any) => element.id !== e.id),
        );
        break;
    }
  };

  const handleAssociation = (accessorKey: string, value: any) => {
    switch (accessorKey) {
      case "corporates":
        const objToAssociation: any = Object.keys(value).map((key: string) => {
          if (key.includes("||")) {
            return {
              id: key.split("||")[0],
              label: key.split("||")[1],
            };
          } else {
            return corporateAssociation.find((elem: any) => elem.id === +key);
          }
        });
        setCorporateAssociation(objToAssociation);
        break;
    }
  };

  let inputsException = (col: any, inputForm: any) => {
    if (col.accessorKey === "corporates") {
      if (inputForm?.allCorporateAssociation) {
        if (isTrueValue(inputForm.allCorporateAssociation)) {
          return { ...col, disabled: true, required: false };
        } else {
          return { ...col, disabled: false, required: true };
        }
      }
    }
    if (col.accessorKey === "all_corporates_association") {
      if (corporateAssociation && corporateAssociation.length > 0) {
        return { ...col, disabled: true };
      } else {
        return { ...col, disabled: false };
      }
    }
    return col;
  };

  let formatedData = useMemo(() => {
    if (dataTable && dataTable?.output) {
      return { ...dataTable?.output[0] };
    } else {
      return {};
    }
  }, [dataTable]);

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-certificates.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("edit.hero-title")}
          description={t("edit.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <AddEditFormCst
              row={formatedData}
              columns={columns}
              inputsException={inputsException}
              onSubmit={onSubmit}
              actionsForForms={[]}
              backButton={() => {
                navigate(-1);
              }}
              setOpenAssociation={(accessorKey, open) =>
                setOpenAssociation(accessorKey, open)
              }
              handleDelete={(accessorKey, el) => handleDelete(accessorKey, el)}
              handleAssociation={(accessorKey, value) =>
                handleAssociation(accessorKey, value)
              }
              getValues={(accessorKey) => getValues(accessorKey)}
              association={openAssociations}
              onReset={() => {
                setCorporateAssociation([]);
              }}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-add")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default EditLTIAccount;
